function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-about">
          <h2>Get in Touch</h2>
          <p><strong>TriStar Engineers & Services</strong></p>
          <p>UDYAM CERT-UDYAM-UP-01-0031949</p>
          <p>ISO 9001:2015 Certified Company</p>
          <p>(Manufacturer of Online UPS)</p>
        </div>

        <div className="footer-office">
          <h2>Head Office</h2>
          <p><strong>Address:</strong> D-514, Kalindi Vihar, Agra-282006, Uttar Pradesh</p>
          <p><strong>Phone:</strong> 9557528916, 9559798667</p>
          <p><strong>Email:</strong> tsesagra@gmail.com, sales@tristarengineer.com</p>
          <p><strong>GSTIN:</strong> 09AXJPG1461B1ZU</p>
          <p><strong>State:</strong> 09-Uttar Pradesh</p>
        </div>

        <div className="footer-branches">
          <h2>Branch Offices</h2>

          <div className="branch">
            <p><strong><u>Aligarh Branch:</u></strong></p>
            <p>01 Kunjalpur Melrose Byepass, Aligarh - 9045254017</p>
          </div>

          <div className="branch">
            <p><strong><u>Firozabad Branch:</u></strong></p>
            <p>78/143, Suhag Nagar, Firozabad - 9045254013</p>
          </div>

          <div className="branch">
            <p><strong><u>Bijnor Branch:</u></strong></p>
            <p>206, Mandi Kotla, Chandpur, Bijnor - 9045254015</p>
          </div>

          <div className="branch">
            <p><strong><u>Mathura Branch:</u></strong></p>
            <p>P-236 Radha Vintage Goverdhan Rd. Mathura - 9045254016</p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 TriStar Engineers & Services. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
